<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <h5>Mitigation Installation & Conditions / Limitations in Place</h5>
    </div>
  </div>
  <form-workflow
    [form]="form"
    [sectionNumber]="3"
    [amendmentSectionNumbers]="[11]"
    [service]="service"
  >
  </form-workflow>
</div>
